/*globals ScrollUtil*/

import { node_observable_component } from 'common/util/ComponentDecorator';

@node_observable_component
export default class Pagination {
	static classname = 'pagination';

	constructor($wrapper) {
		this.$wrapper = $wrapper;

		this.bindEvents();
	}

	bindEvents() {
		this.$wrapper.find('a.pagination__item').on('click', function(e){
			e.preventDefault();
			const $pagination = $(this).closest('.pagination');
			const content_classname = $pagination.data('content-classname');
			const url = $(this).attr('href');

			const $categoryProductsSlider = $('.shop-page__category-bestsellers');
			$.get(url, function (html) {
				var $html = $(html);
				const $content = $(`.${content_classname}`).html($html.find(`.${content_classname}`).html());
				$(document).trigger('update_products');
				Update($('.sorting-options'));
				if (!!(history.pushState && history.state !== undefined)) {
					window.history.pushState({}, '', url);
				}

				ScrollUtil.scrollTo($content.offset().top - 15);
			});
		});
	}
}
